export const [
    FETCH_SEARCH_RESULTS
] = [
    'FETCH_SEARCH_RESULTS'
]